import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCljDz2LTZQdm2-YW64C8Ag4GyvKxRUWag',
  authDomain: 'petguardian-53924.firebaseapp.com',
  projectId: 'petguardian-53924',
  storageBucket: 'petguardian-53924.firebasestorage.app',
  messagingSenderId: '329443812151',
  appId: '1:329443812151:web:2c45adfd14b4afcf2c70b2',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
